
/* Rohini 10/29/2022 3075154998 add classname globally for the textfields and buttons */
import React, {useEffect, useState, useContext} from 'react';
import {Formik} from 'formik';
import {Button, Grid, TextField, InputAdornment} from '@material-ui/core';
import {DISPOSITION_CODE} from '../../../../../../constants/Lookup';
import {useDispatch, useSelector} from 'react-redux';
import {fetchDispositionCodes} from '../../../../../../redux/reducers/EventTactics/EventTactics';
import SearchRecordFormat from '../../../../RecordFormat/SearchRecordFormat';
import {
  handleRecordFormatSearchField,
  resettingFieldData,
} from '../../../../../../redux/reducers/BRE/AddRecordFormat';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import {ArrowBack, Search, Clear} from '@material-ui/icons';
import GuiAutoComplete from '../../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';

const ActionForm = ({
  setActionData,
  actionData,
  setActionOpen,
  actionRowData,
  isEditMode,
  setIsEditMode,
  actionCode,
  setParameter,
}) => {
  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {dispositionDropDown} = useSelector(({addEventTactic}) => addEventTactic);
  const [showSearchFieldData, setShowSearchFieldData] = useState(false);
  const initialValues = {
    operator: isEditMode && actionRowData?.operator ? actionRowData?.operator : '',
    toField: isEditMode && actionRowData?.toField ? actionRowData?.toField : '',
    fieldCode: '',
    sourceField: isEditMode && actionRowData?.sourceField ? actionRowData?.sourceField : '',
    format: isEditMode && actionRowData?.format ? actionRowData?.format : '',
    type: isEditMode && actionRowData?.type ? actionRowData?.type : '',
    recordFormat: isEditMode && actionRowData?.recordFormat ? actionRowData?.recordFormat : '',
    expression: isEditMode && actionRowData?.expression ? actionRowData?.expression : '',
    actionName: isEditMode && actionRowData?.actionName ? actionRowData?.actionName : '',
    description: isEditMode && actionRowData?.description ? actionRowData?.description : '',
    returnType: isEditMode && actionRowData?.returnType ? actionRowData?.returnType : '',
  };

  const dataTypeOptions = [
    {key: 'Set', value: 'Set'},
    {key: 'Change Disposition', value: 'Change Disposition'},
    {key: 'Make Report Line', value: 'Make Report Line'},
    {key: 'Make Record', value: 'Make Record'},
  ];

  const dateFormatOptions = [
    {key: 'MDY', value: 'MDY'},
    {key: 'YMD', value: 'YMD'},
  ];
  useEffect(() => {
    dispatch(fetchDispositionCodes());
  }, []);
  const getOptions = (typeCode) => {
    let label = [];
    label =
      dispositionDropDown && dispositionDropDown[typeCode] ? dispositionDropDown[typeCode] : [];

    return label;
  };
  const handleSubmit = (data) => {
    const copiedData = [...actionData];
    if (!isEditMode) {
      copiedData.push({...data});
      setActionData(copiedData);
      setActionOpen(false);
    } else {
      const updatedActionData = copiedData.map((item, i) => {
        if (i === actionCode) {
          return {
            ...item,
            operator: data?.operator,
            toField: data?.toField,
            fieldCode: '',
            sourceField: data?.sourceField,
            format: data?.format,
            type: data?.type,
            recordFormat: data?.recordFormat,
            expression: data?.expression,
            actionName: data?.actionName,
            description: data?.description,
            returnType: data?.returnType,
            sequenceNo: i + 1,
            disposition: data?.disposition,
          };
        } else {
          return {...item};
        }
      });
      setActionData(updatedActionData);
      setActionOpen(false);
      setIsEditMode(false);
    }
  };
  return (
    <div className={classes.dialoguecardStyles}>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        enableReinitialize
      >
        {(props) => {
          const {values, handleChange, handleSubmit, handleReset, handleBlur, setFieldValue} =
            props;
          return (
            <div>
              {showSearchFieldData ? (
                <>
                  <Button
                    variant="text"
                    className={`"mb-2" ${classes.goBackBtn}`}
                    onClick={() => {
                      setShowSearchFieldData(false);
                    }}
                  >
                    <ArrowBack className="mr-2" />
                    Go Back
                  </Button>
                  <SearchRecordFormat />
                </>
              ) : (
                <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                  <div>
                    <Grid container className="global-field-textfields">
                      <Grid sm={6} md={4} className="px-1 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="type"
                          id="type"
                          size="small"
                          value={values.type}
                          options={dataTypeOptions.map((item) => item.value)}
                          onChange={(e, value) => {
                            setFieldValue('type', value);
                            setFieldValue('recordFormat', '');
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                className={` ${classes.labelName} ${classes.selectLabel}`}
                                variant="outlined"
                                margin="dense"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                label="Action Type"
                                placeholder="Select Action Type"
                              />
                            </div>
                          )}
                        />
                      </Grid>

                      {values.type === 'Set' && (
                        <Grid container>
                          <Grid sm={6} md={4} className="px-1 form-group">
                            <TextField
                              margin="dense"
                              className={` ${classes.labelName} ${classes.inputLabel}`}
                              variant="outlined"
                              placeholder="Enter To Field"
                              label="To Field"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name="toField"
                              value={values.toField}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              fullWidth
                            />
                          </Grid>
                          <Grid sm={6} md={4} className="px-1 form-group">
                            <TextField
                              margin="dense"
                              className={` ${classes.labelName} ${classes.inputLabel}`}
                              variant="outlined"
                              placeholder={`Enter Expression`}
                              label="Expression"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name="expression"
                              value={values.expression}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              fullWidth
                            />
                          </Grid>
                          <Grid sm={6} md={4} className="px-1 form-group">
                            <GuiAutoComplete
                              classes={{
                                option: classes.option,
                              }}
                              name="format"
                              id="format"
                              size="small"
                              value={values.format}
                              options={dateFormatOptions.map((item) => item.value)}
                              onChange={(e, value) => {
                                setFieldValue('format', value);
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              renderInput={(params) => (
                                <div className="select-field">
                                  <GuiTextField
                                    {...params}
                                    variant="outlined"
                                    className={` ${classes.labelName} ${classes.selectLabel}`}
                                    margin="dense"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    label="Date Format"
                                    placeholder="Select Date Format"
                                  />
                                </div>
                              )}
                            />
                          </Grid>
                        </Grid>
                      )}
                      {values.type === 'Change Disposition' && (
                        <Grid sm={6} md={4} className="px-1 form-group">
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            id="disposition"
                            size="small"
                            value={values.disposition}
                            onChange={(e, value) => {
                              setFieldValue('disposition', value);
                            }}
                            options={getOptions(DISPOSITION_CODE)}
                            getOptionLabel={(option) => {
                              return option && option.value ?
                                option.valueCode === null ?
                                  option.value :
                                  option.valueCode + ' - ' + option.value :
                                '';
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  variant="outlined"
                                  className={` ${classes.labelName} ${classes.selectLabel}`}
                                  margin="dense"
                                  name="disposition"
                                  InputLabelProps={{shrink: true}}
                                  label={'Status'}
                                  placeholder={`Select Status`}
                                />
                              </div>
                            )}
                          />
                        </Grid>
                      )}
                      {values.type === 'Make Report Line' && (
                        <Grid sm={6} md={4} className="px-1 form-group">
                          <TextField
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="outlined"
                            placeholder="Enter Record Format"
                            label="Record Format"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="recordFormat"
                            value={values.recordFormat}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            disabled
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Search
                                    className={` ${classes.iconSearch}`}
                                    onClick={() => {
                                      setShowSearchFieldData(true);
                                      dispatch(
                                        handleRecordFormatSearchField({
                                          status: true,
                                          setFieldValue,
                                          setShowSearchFieldData,
                                        }),
                                      );
                                    }}
                                  >
                                    Search
                                  </Search>
                                  <Clear
                                    className={` ${classes.iconSearch}`}
                                    onClick={(e) => setFieldValue('recordFormat', '')}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                      )}
                      {values.type === 'Make Record' && (
                        <Grid sm={6} md={4} className="px-1 form-group">
                          <TextField
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="outlined"
                            placeholder="Enter Record Format"
                            label="Record Format"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="recordFormat"
                            value={values.recordFormat}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled
                            fullWidth
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Search
                                    className={` ${classes.iconSearch}`}
                                    onClick={() => {
                                      setShowSearchFieldData(true);
                                      dispatch(
                                        handleRecordFormatSearchField({
                                          status: true,
                                          setFieldValue,
                                          setShowSearchFieldData,
                                        }),
                                      );
                                    }}
                                  >
                                    Search
                                  </Search>
                                  <Clear
                                    className={` ${classes.iconSearch}`}
                                    onClick={(e) => setFieldValue('recordFormat', '')}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </div>
                  <div className="text-center">
                    <div className="button-spacing-mb">
                      <Button
                        type="button"
                        onClick={() => handleReset()}
                        variant="outlined"
                        className={`mx-1 reset-btn${classes.buttonRoot}`}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="outlined"
                        className={`search-btn mx-1 ${classes.buttonRoot}`}
                        onClick={() => dispatch(resettingFieldData())}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default ActionForm;
